import useClient from '@pkg/client/useClient';

export const LOGOUT_USER = /* GraphQL */ `
  mutation Logout($id: ID!) {
    logout(id: $id) {
      id
    }
  }
`;

export default function useLogoutEvent(id) {
  const client = useClient();

  async function triggerLogout() {
    return await client.graphql({
      query: LOGOUT_USER,
      variables: { id },
    });
  }

  return triggerLogout;
}
